<template>
  <div class="CiteScore" v-if="tableData && tableData.length">
    <div class="CiteScore_box">
      <div class="CiteScore_box_left">
        <div>
          <p class="CiteScore_box_left_title">WOS期刊SCI分区</p>
          <p v-if="tableData[0].version">
            ( <span>{{ tableData[0].version }}</span> )
          </p>
        </div>
      </div>
      <div class="CiteScore_box_right">
        <div class="CiteScore_box_right_wosLevel">
          WOS分区等级：<span>{{ tableData[0].wosLevel }}</span>
        </div>
        <!-- JIF分区表格 -->
        <el-table class="CiteScore_box_right_table mb-20" border :data="jifTableData">
          <el-table-column label="按JIF指标学科分区" width="200" align="center">
            <template slot-scope="scope">
              <div>学科：{{ scope.row.subjectCategory }}</div>
            </template>
          </el-table-column>
          <el-table-column label="收录子集" width="80" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.includedSubset }}</div>
            </template>
          </el-table-column>
          <el-table-column label="JIF分区" width="80" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.partition }}</div>
            </template>
          </el-table-column>
          <el-table-column label="JIF排名" width="80" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.rank + "/" + scope.row.journalNumber }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="JIF百分比" width="100">
            <template slot-scope="scope">
              <div style="text-align: center;padding:0 20px;">
                {{ scope.row.percentile }}
                <el-progress
                  color="#5FB878"
                  :show-text="false"
                  :percentage="parseInt(scope.row.percentile)"
                ></el-progress>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- JCI分区表格 -->
        <el-table class="CiteScore_box_right_table" border :data="jciTableData">
          <el-table-column label="按JCI指标学科分区" width="200" align="center">
            <template slot-scope="scope">
              <div>学科：{{ scope.row.subjectCategory }}</div>
            </template>
          </el-table-column>
          <el-table-column label="收录子集" width="80" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.includedSubset }}</div>
            </template>
          </el-table-column>
          <el-table-column label="JCI分区" width="80" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.partition }}</div>
            </template>
          </el-table-column>
          <el-table-column label="JCI排名" width="80" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.rank + "/" + scope.row.journalNumber }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="JCI百分比" width="100">
            <template slot-scope="scope">
              <div style="text-align: center;padding:0 20px;">
                {{ scope.row.percentile }}
                <el-progress
                  color="#5FB878"
                  :show-text="false"
                  :percentage="parseInt(scope.row.percentile)"
                ></el-progress>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GetjcrRank } from "@/api/analysis";
export default {
  name: "CiteScore",
  computed: {
    ...mapGetters({
      magId: "magId"
    }),
    jifTableData() {
      return this.tableData.filter(item => item.rankType === "JIF")
    },
    jciTableData() {
      return this.tableData.filter(item => item.rankType === "JCI")
    }
  },
  data() {
    return {
      tableData: []
    };
  },
  created() {
    this.GetjcrRank();
  },
  methods: {
    GetjcrRank() {
      let params = {
        magId: this.magId
      };
      GetjcrRank(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          this.tableData = res.data.data;
          console.log(this.tableData, "tableData");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.CiteScore {
  text-align: left;
  &_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #e2e2e2;
    &_left {
      padding: 0 20px;
      min-width: 15%;
      max-width: 15%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &_title {
        display: flex;
        align-items: center;
        i {
          color: #FFABAA;
          font-size: 20px;
          cursor: pointer;
          margin-left: 5px;
        }
      }
      p {
        font-size: 14px;
        color: #333;
        margin-bottom: 5px;
        font-weight: bolder;
        span {
          color: red;
        }
      }
    }
    &_right {
      padding: 20px;
      border-left: 1px solid #e2e2e2;
      overflow: hidden;
      &_wosLevel {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        span {
          background: #FFEEEE;
          border: 1px solid #FFB1B1;
          color: #60609B;
          font-size: 12px;
          padding: 0 5px;
        }
      }
      &_table {
        width: 100%;
        color: #666;
        /deep/ th.el-table__cell {
          background: #f6f6f6 !important;
        }
      }
      .editLink {
        color: #2e9aff;
        cursor: pointer;
      }
    }
  }
}
</style>
